/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
// import 'ace-builds/src-noconflict/theme-monokai'
import "ace-builds/src-noconflict/theme-chrome";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-spellcheck";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import LabelledField from "components/labelled-field";
import debounce from "lodash.debounce";

const editorTheme = "chrome";

const JSONFieldItemEdit = () => {
    
    const { t } = useTranslation();
    const ctx = useContext(ListItemContext)
    const index = ctx?.index;
    const value = ctx?.value;
    const settings = ctx.settings;
    const updateListItem = ctx?.updateListItem
    
    const initialState = {
        value: value ? value : "",
        settings
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);
    const [editorState, setEditorState] = useState();
    const [editorloaded, setEditorloaded] = useState();
    
    useEffect(() => {
        if (!editorState) {
            // only on load
            setEditorState(value);
            setEditorloaded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editorState]);

    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    
    const handleEditorChange = (value) => {
        setEditorState(value);
        const updatedValue = { ...itemLocalState, value: value };
        setItemLocalState(updatedValue);
        update(updatedValue, index);
    };
    
    return (
        <Fragment>

            <LabelledField
                label={t("commons.editJSON")}
                className='labelField'
            >
                <div style={{ border: "1px solid black", width: "100%" }}>
                    {editorloaded &&
                        <AceEditor
                            value={editorState}
                            mode='json'
                            theme={editorTheme}
                            onChange={handleEditorChange}
                            name={`simplicity-json-editor-${index}`}
                            editorProps={{ $blockScrolling: true }}
                            setOptions={{
                                useWorker: false,
                                enableBasicAutocompletion: true,
                                enableLiveAutocompletion: true,
                                enableSnippets: true,
                                showPrintMargin: false,
                            }}
                            width='100%'
                            height='400px'
                            tabsize='2'
                            style={{ minHeight: "200px" }}
                        />
                    }
                </div>
            </LabelledField>
            
        </Fragment>
    );
};
export { JSONFieldItemEdit };
